import { routerMiddleware } from "@/_shared/middlewares";

import MainPage from "@/user/pages/MainPage";
import AllUsersPage from "@/user/pages/AllUsersPage";
import UserPage from "@/user/pages/UserPage";
import LoginHistoryPage from "@/user/pages/LoginHistoryPage";
import AllShiftsCalendarsPage from "@/user/pages/AllShiftsCalendarsPage";
import ShiftsCalendarPage from '@/user/pages/ShiftsCalendarPage';
import PersonalAreaPage from '@/user/pages/PersonalAreaPage';
import WorkAnalyticsPage from '@/user/pages/WorkAnalyticsPage';
import AllAchievementsPage from '@/user/pages/AllAchievementsPage';
import AchievementPage from '@/user/pages/AchievementPage';

const routes = [
  {
    path: "/personal_area",
    component: PersonalAreaPage,
  },
  {
    path: "/",
    component: MainPage,
  },
  {
    path: "/personal_info",
    component: UserPage,
  },
  {
    path: "/login_history",
    component: LoginHistoryPage,
    beforeEnter: routerMiddleware.checkUserPermissions,
  },
  {
    path: "/shifts_calendars",
    component: AllShiftsCalendarsPage,
    beforeEnter: routerMiddleware.checkUserPermissions,
  },
  {
    path: "/shifts_calendars/:id",
    component: ShiftsCalendarPage,
    beforeEnter: routerMiddleware.checkUserPermissions,
  },
  {
    path: "/users",
    component: AllUsersPage,
    beforeEnter: routerMiddleware.checkUserPermissions,
  },
  {
    path: "/users/:id",
    component: UserPage,
    beforeEnter: routerMiddleware.checkUserPermissions,
  },
  {
    path: "/analytics/work",
    component: WorkAnalyticsPage,
    beforeEnter: routerMiddleware.checkUserPermissions,
  },
  {
    path: "/achievements",
    component: AllAchievementsPage,
    beforeEnter: routerMiddleware.checkUserPermissions,
  },
  {
    path: "/achievements/:new",
    component: AchievementPage,
    beforeEnter: routerMiddleware.checkUserPermissions,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/user/routes.js